import Container from '@/containers/lp/Sim'
import { useRouter } from 'next/router'
import { Thanks } from '@/route'
import Head from 'next/head'

const Page = () => {
  const router = useRouter()
  const toThanks = () => {
    router.replace(Thanks)
  }
  const title = "1枚からすぐに始められるIoT/M2M向け法人SIM"
  const description = "最短即日発送・縛りなし・利用シーンに合わせたプランをご用意"
  return (
    <>
      <Head>
        <title key="title">{title}</title>
        <meta property="og:url" content={`https://iot.dxhub.co.jp/lp`} key="ou" />
        <meta property="og:title" content={title} key="ot" />
        <meta name="description" content={description} key="description" />
        <meta property="og:description" content={description} key="od" />
      </Head>
      <Container toThanks={toThanks} />
    </>
  )
}

Page.isWithoutLayout = true

export default Page
